module.exports = __webpack_public_path__ + "img/location1.9510e0b3.png";